import { TextBoxField, Select } from '@/components';
import type { Control, UseFormRegister, FieldErrors } from 'react-hook-form';
import type { SelectOption } from '@/components/common/Select';
import type { TouchPointFormData } from '../TouchPointModal';

interface SocialPropertiesSectionProps {
  control: Control<TouchPointFormData>;
  register: UseFormRegister<TouchPointFormData>;
  errors: FieldErrors<TouchPointFormData>;
  platformOptions: SelectOption[];
}

export function SocialPropertiesSection({ control, register, errors, platformOptions }: SocialPropertiesSectionProps) {
  return (
    <div className="space-y-6 pt-4 border-t border-slate-200 dark:border-slate-600 md:border-0 md:pt-0">
      <h3 className="text-lg font-medium text-slate-900 dark:text-white">
        Social Properties
      </h3>

      <Select
        label="Platform"
        required
        options={platformOptions}
        placeholder="Select platform..."
        error={errors.Platform?.message}
        {...register('Platform', {
          required: 'Platform is required'
        })}
      />

      <TextBoxField
        control={control}
        name="PostCopy"
        label="Post Copy"
        required
        multiline
        rows={6}
        placeholder="Social media post content..."
        showCharCounter
        maxLength={5000}
        rules={{
          required: 'Post copy is required',
          maxLength: { value: 5000, message: 'Post copy must be 5000 characters or less' }
        }}
      />
    </div>
  );
}
